import { Serializable } from '@/models/core/serializable';
import { JgrowEventLikertScaleItem } from '@/models/jgrow/jgrow-event-likert-scale-item';

export class JgrowEventLikertScaleAnalysis implements Serializable<JgrowEventLikertScaleAnalysis> {
  title: string; // リッカート尺度選択肢文言
  value: number; // 回答番号
  count: number = 0;

  deserialize(input: JgrowEventLikertScaleItem): JgrowEventLikertScaleAnalysis {
    this.title = input.title;
    this.value = input.value;

    return this;
  }

  getPercentByTotal(total: number): number {
    if (this.count === 0) {
      return 0;
    }
    return (this.count / total) * 100;
  }

}
